module.exports = __webpack_public_path__ + "img/bb-logo.71d3c0f0.png";